import React, { Fragment } from 'react'
import { Link } from '@hub/link'

interface PotentialLinkProps {
  children: React.ReactNode
  href?: string
  external?: boolean
  className?: string
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void
}

const PotentialLink: React.FC<PotentialLinkProps> = ({
  children,
  href,
  className,
  onClick,
  ...props
}): JSX.Element => {
  if (href) {
    return (
      <Link {...props} className={className} href={href} onClick={onClick}>
        {children}
      </Link>
    )
  }

  return <Fragment>{children}</Fragment>
}

export default PotentialLink
